import { useMemo } from 'react';
import { useGetProjectQuery } from '../api';
/**
 * Hook to get a single project.
 *
 * @param projectId the project id to fetch.
 * @param isHidden whether to include hidden projects.
 *
 * @returns an object with a project, loading state, error state and error object.
 */
export const useProject = (projectId, isHidden) => {
    const { data: project, isLoading, isError, error, } = useGetProjectQuery({
        projectId,
        ...(isHidden !== undefined && { isHidden }),
    });
    return useMemo(() => ({
        project,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, project]);
};
